import { createRoot } from 'react-dom/client'

import type { ResourceLoaderQueue } from '~/@types/rlq'
import type {} from '~/@types/rlq'

import { LatestArticleList } from './page-list'

;(window.RLQ ??= [] as unknown as ResourceLoaderQueue).push(['mediawiki.api', () => replaceDom()])

function replaceDom() {
	const rawLinks = getRawLinks()
	if (rawLinks.length === 0) return

	const rootElem = document.getElementById('latest-article-list')
	if (!rootElem) {
		console.error('未找到ID为`latest-article-list`的元素')
		return
	}
	const root = createRoot(rootElem)
	root.render(<LatestArticleList pages={rawLinks} />)
}

interface RawLink {
	href: string
	title: string
}

function getRawLinks(): RawLink[] {
	const rawLinks: RawLink[] = Array.from(
		document.querySelectorAll<HTMLAnchorElement>('#latest-article-list li a'),
		(elem) => {
			return {
				href: elem.getAttribute('href')!,
				title: elem.title,
			}
		},
	)
	return rawLinks
}
